module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_dark.bd1d65b7.svg";